// extracted by mini-css-extract-plugin
export default {"menu":"Navigation_menu__a6PLR","list":"Navigation_list__AAMWN","link":"Navigation_link__OWMsq","activeLink":"Navigation_activeLink__lEs2v","underline":"Navigation_underline__8lNbG"};